<template>
<div>
  <button>imprimir</button>
  <body style="font-family: Arial; font-size: 13.5px;">
    <div class="print-container clearfix">
          <div class="flex-container">
            <div style="flex-grow: 1">
              <img id ="img1" class="invoice-logo" src="../../assets/img/logo2.png" alt=""  />
            </div>
          </div>
          <div class="flex-container">
            <div style="flex-grow: 6">
              <h5 style="text-align: center; padding-top: 18px; font-size: 20px">Reporte Diario Interno de Obra (RDIO)</h5>
            </div>
          </div>

          <b-container class="bv-example-row">
            <b-row>
              <b-col sm style= "border: 1px solid #000;">Proyecto: {{getProp('nombre_proyecto')}}</b-col>
              <b-col sm style= "border: 1px solid #000;">Locación: {{getProp('locacion')}}</b-col>
              <b-col sm style= "border: 1px solid #000;">Fecha:    {{getProp('fecha')}}</b-col>
              <b-col sm style= "border: 1px solid #000;">Cliente:  {{getProp('cliente')}}</b-col>
            </b-row>
          </b-container>
    </div>

    <div class="print-container clearfix" >
            <span><b>Especialidad</b></span>
            <b-card-group deck>
               <template v-if="metadata.especialidad" >
                <b-card body bg-variant="Secondary" text-variant="dark" class="text-center">
                  <div v-for="choice in metadata.especialidad.children.tipo_especialidad.choices" v-bind:key="choice.value">
                    <template v-if="getProp('tipo_especialidad') === choice.value">
                      <span>
                        <strong >
                          {{choice.display_name}}
                        </strong>
                      </span>
                    </template>
                  </div>
                  </b-card>
                </template>
            </b-card-group>
    </div>
    <div class="print-container clearfix" >
        <span><b>Parte de Producción</b></span>
        <p><b> Actividades</b></p>

        <div v-for="i in 5" v-bind:key="'produccion_'+(i-1) "
                class = "row; center-block" style="line-height: 15px;">
                <div role="tablist">
                  <template v-if="produccion[i-1]">
                    <template v-if="i == 1">
                      <b-card no-body class="mb-1">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                          <b-button block href="#" v-b-toggle="'accordion-' + i" variant="info">Actividad {{i}}</b-button>
                        </b-card-header>
                        <b-collapse id="accordion-1" visible accordion="my-accordion" role="tabpanel">
                          <b-card-body>
                            <div class = "flex-container">
                              <div style="flex-grow: 1;">
                                <div class="center-block" style="line-height: 75px;">
                                  <b-card-text>Descripción: {{produccion[i-1].actividad.nombre_actividad}}</b-card-text>
                                </div>
                              </div>
                              <div style="flex-grow: 1; text-align: left;" >
                                <div class="center-block" style="line-height: 8px;">
                                  <b-card-text>Unidad: {{produccion[i-1].unidad}}</b-card-text>
                                  <b-card-text>Cantidad: {{produccion[i-1].cantidad}}</b-card-text>
                                  <b-card-text>Horas: {{produccion[i-1].horas}}</b-card-text>
                                  <b-card-text>Partida: {{produccion[i-1].actividad.partida}}</b-card-text>
                                </div>
                              </div>
                            </div>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                    </template>
                    <template v-else>
                      <b-card no-body class="mb-1">
                        <b-card-header header-tag="header" class="p-1" role="tab">
                          <b-button block href="#" v-b-toggle="'accordion-' + i" variant="info">Actividad {{i}}</b-button>
                        </b-card-header>
                        <b-collapse id="accordion-2" accordion="my-accordion" role="tabpanel">
                          <b-card-body>
                            <div class = "flex-container">
                              <div style="flex-grow: 1;">
                                  <div class="center-block" style="line-height: 75px;">
                                    <b-card-text>Descripción: {{produccion[i-1].actividad.nombre_actividad}}</b-card-text>
                                  </div>
                              </div>
                              <div style="flex-grow: 1; text-align: left;" >
                                  <div class="center-block" style="line-height: 8px;">
                                    <b-card-text>Unidad: {{produccion[i-1].unidad}}</b-card-text>
                                    <b-card-text>Cantidad: {{produccion[i-1].cantidad}}</b-card-text>
                                    <b-card-text>Horas: {{produccion[i-1].horas}}</b-card-text>
                                    <b-card-text>Partida: {{produccion[i-1].actividad.partida}}</b-card-text>
                                  </div>
                              </div>
                            </div>
                          </b-card-body>
                        </b-collapse>
                      </b-card>
                    </template>
                  </template>
                </div>
        </div>
    </div>
    <div class="print-container clearfix" >
        <span><b>Tareo Diario Mano de Obra</b></span>
        <p><b>Personal</b></p>
    </div>

    <div class="print-container clearfix" >
      <div v-if="metadata.comentarios!=null">
        <span><b>Comentarios</b></span>
      </div>
      <div v-if = "typeof text === 'string'">
        <b-form-textarea
          id="textarea-plaintext"
          size = "sm"
          plaintext :value= "text"
          rows="3"
          max-rows="6">
        </b-form-textarea>
      </div>

    </div>

    <div class="print-container clearfix" >
      <div>
        <b-card-group deck>
          <b-card bg-variant="Secondary" text-variant="dark" header="Capataz" class="text-center">
            <b-card-text style = "text-align: center;">{{getProp('capataz')}}</b-card-text>
          </b-card>

          <b-card bg-variant="Secondary" text-variant="dark" header="Supervisor" class="text-center">
            <b-card-text style = "text-align: center;">{{getProp('supervisor')}}</b-card-text>
          </b-card>

          <b-card bg-variant="Secondary" text-variant="dark" header="Responsable" class="text-center">
            <b-card-text style = "text-align: center;">{{getProp('responsable')}}</b-card-text>
          </b-card>
        </b-card-group>
      </div>
    </div>

  </body>
  <pre>
    {{rdio}}
  </pre>
</div>
</template>

<script>
import Base from '../Base.vue'
// import jsPDF from 'jspdf'

export default {
  extends: Base,
  watch: {
    db (to, from) {
      if (to) {
        this.loadRdio()
      }
    }
  },
  data () {
    return {
      rdio: {},
      loadedFiles: {},
      produccion: [],
      tareo_diario: [],
      matriz: [],
      equipo_general: [],
      material_combustible: [],
      text: {}
    }
  },
  methods: {
    loadRdio () {
      let obj = this
      if (this.$route.params.id !== '0' && this.$route.params.id !== 0) {
        obj.getdata(this.$route.params.id, true).then(function (data) {
          obj.$set(obj, 'rdio', data)
          obj.$set(obj, 'produccion', data.produccion)
          obj.$set(obj, 'tareo_diario', data.tareo_diario)
          obj.$set(obj, 'equipo_general', data.equipo_general)
          obj.$set(obj, 'material_combustible', data.material_combustible)
          obj.$set(obj, 'text', data)
          obj.matriz = []
          obj.matriz2 = []
          obj.matriz3 = []
          obj.matriz4 = []
          obj.text = obj.text.comentarios
          for (var i = 0; i < 25; i++) {
            obj.matriz.push([])
            for (var j = 0; j < 10; j++) {
              obj.matriz[i].push('')
            }
          }
          for (var y = 0; y < 10; y++) {
            if (obj.tareo_diario[y]) {
              for (var z in obj.tareo_diario[y].actividades) {
                var x = parseInt(obj.tareo_diario[y].actividades[z].actividad_x_personal) - 1
                obj.matriz[y][x] = obj.tareo_diario[y].actividades[z].horas_x_personal
              }
            }
          }
          for (i = 0; i < 10; i++) {
            obj.matriz2.push([])
            for (j = 0; j < 10; j++) {
              obj.matriz2[i].push('')
            }
          }
          for (y = 0; y < 10; y++) {
            if (obj.equipo_general[y]) {
              for (var w in obj.equipo_general[y].actividades) {
                var v = parseInt(obj.equipo_general[y].actividades[w].actividad_x_equipo) - 1
                obj.matriz2[y][v] = obj.equipo_general[y].actividades[w].horas_x_equipo
              }
            }
          }
          for (i = 0; i < 10; i++) {
            obj.matriz3.push([])
            for (j = 0; j < 10; j++) {
              obj.matriz3[i].push('')
            }
          }
          for (y = 0; y < 10; y++) {
            if (obj.material_combustible[y]) {
              for (w in obj.material_combustible[y].actividades) {
                v = parseInt(obj.material_combustible[y].actividades[w].actividad_x_material) - 1
                obj.matriz3[y][v] = obj.material_combustible[y].actividades[w].horas_x_material
              }
            }
          }
          for (var filename in obj.rdio._attachments) {
            obj.addLoadedFile(filename)
          }
        }).catch(function (err) {
          console.log(err)
        })
      }
    },
    addLoadedFile (id) {
      this.loadedFiles[id] = window.URL.createObjectURL(this.rdio._attachments[id].data)
    },
    getPropRec (obj, name) {
      if (obj !== null && typeof obj === 'object') {
        if (name in obj) { return obj[name] }
        for (var i in obj) {
          var val = this.getPropRec(obj[i], name)
          if (val !== null) { return val }
        }
      }
      return null
    },
    getProp (name, defaults = '') {
      var val = this.getPropRec(this.rdio, name)
      if (val !== null) {
        return val
      } else {
        return defaults
      }
    },
    getPropDisplay (name, defaults = '') {
      var value = this.getProp(name, null)
      var children = this.getPropRec(this.metadata, name)
      for (var i in children.choices) {
        var choice = children.choices[i]
        if (choice.value === value) { return choice.display_name }
      }
      return defaults
    },
    getPropEsp (name, defaults) {
      var val = this.getPropRec(this.radio, name)
      if (val !== null) {
        switch (defaults) {
          case (defaults === 'Civil'):
            return defaults
          case (defaults === 'Metalmecánica'):
            return defaults
          case (defaults === 'Electricidad'):
            return defaults
          case (defaults === 'Instrumentación'):
            return defaults
          case (defaults === 'Serv. Generales'):
            return defaults
          case (defaults === 'Mantenimiento'):
            return defaults
          case (defaults === 'Equipo Mecánico'):
            return defaults
          case (defaults === 'Gestión'):
            return defaults
          case (defaults === 'Otros'):
            return defaults
        }
      } else {
        return defaults
      }
    }
  }
}
</script>

<style>
li{
  margin: 0px;
  padding: 0px;
}
ul{
  margin: 0px;
  padding: 0px;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;

}

th, td {
  text-align: left;
  padding-left: 6px;
  padding-right: 6px;
}

.flex-container {
  display: flex;
  justify-content: stretch;

}

.flex-container > div {
  width: auto;
  margin: 0px;
  text-align: center;
  line-height: 35px;
  font-size: 14px;

  justify-content: center;

}
.invoice-logo {
  height: 50px;
  width: auto;
}

tr:nth-child(even){background-color: #fff}

.print-container {
    max-width: 1250px;
    margin: 5px auto;
    background: white;
    padding: 2px 30px;

  }
  .print-container .header {
    margin-bottom: 0px;
    border-bottom: 0px solid #dbdbdb;
    padding-bottom: 0px;
  }
  .print-container table {
    margin-top: 0px;
  }
  .print-container table tbody tr.no-border:first-child {
    opacity: 0.6 !important;
  }
  .print-container .summary-table {
    border: 1px solid #DDE1E4;
  }
  .print-container .summary-table tr td:last-child {
    text-align: right;
  }
  .print-container .summary-table tr th:last-child {
    text-align: right;
  }
  .print-container .summary-table td {
    border-left: 1px solid #dbdbdb;
  }
  .print-container .summary-table th {
    border-left: 1px solid #dbdbdb;
  }
  .print-container .summary-table thead {
    color: #737F8B;
    text-transform: uppercase;
  }
  .print-container .ft-18 {
    font-size: 20px;
    margin-bottom: 10px;
  }
  .print-container .adder {
    font-size: 16px;
    font-weight: 500;
    text-align: right;
    border-left: 0;
    border-right: 0;
    border-bottom: 0;
  }
  .print-container .total {
    font-size: 22px;
  }
  .print-container .mega {
    font-size: 33px;
    margin-bottom: 10px;
  }
  .row {
    margin-left: 0.0px;
  }
  .card-header{
    font-weight: bold;
  }

  @media print {
    h1, h2, h3, h4, h5, h6 {
      font-weight: bold;
    }
    h1:first-letter, h2:first-letter, h3:first-letter, h4:first-letter, h5:first-letter, h6:first-letter {
      font-size: inherit;
    }
  }
</style>
